<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oVlJEe/media/FC-9781398434295.jpg?1684514917785" alt="This image is the cover for the book The Vagrant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Vagrant
      </h1>
      <p class="bookDescription body article font2">
        <p>Where do you go for answers in the age of information? How do you love in grey areas of echoed ideas? When does understanding become manipulation? Forced into self-reflection, Eilidh explores the idea that no single answer is an entirely palatable truth – not when it comes to friends, philosophies or men.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lincoln Kate
      </h2>
      
      <p class="authorDescription body article">Lincoln Kate’s longest love has always been language. She is an experience thief with the aim to enjoy life by understanding it. When not in the sun or between pages, she can be found teaching teens or stealing stories. Cover art: Daniel Bennett</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b276e10